import { create } from "zustand";

const useMembersStore = create((set) => ({
  membershipData: null,
  setMembershipData: (data) => set({ membershipData: data }),
}));

export default useMembersStore;
